import type { AdvancedClosedOrderStatus } from '@/constants/advancedOrder';

export type FiltersReducerState = {
  status?: AdvancedClosedOrderStatus;
  time: number | 'ytd' | 'previous_year';
  networks: string[];
  orderTypes: string[];
};

export const FILTER_ACTIONS = {
  UPDATE_NETWORKS: 'update networks',
  UPDATE_ORDER_TYPES: 'update order types',
  UPDATE_STATUS: 'update status',
  UPDATE_TIME: 'update time',
  UPDATE_ALL_FILTERS: 'update all filters',
  CLEAR: 'clear',
} as const;

type FiltersActionTypes =
  | { type: 'update time'; payload: number }
  | { type: 'update networks'; payload: string[] }
  | { type: 'update order types'; payload: string[] }
  | { type: 'update status'; payload: AdvancedClosedOrderStatus | undefined }
  | { type: 'update all filters'; payload: FiltersReducerState }
  | { type: 'clear' };

export type TimeFilterValue = number | 'ytd' | 'previous_year';

export const timeFilters: { label: string; value: TimeFilterValue }[] = [
  { label: 'All time', value: 0 },
  { label: 'Last 24 hours', value: 1440 },
  { label: 'Last 7 days', value: 10080 },
  { label: 'Last 30 days', value: 43200 },
  { label: 'Last 12 months', value: 525600 },
  { label: 'Year to date', value: 'ytd' },
  { label: 'Previous year', value: 'previous_year' },
];

export const DEFAULT_FILTERS_STATE = {
  time: 0,
  networks: [],
  orderTypes: [],
  status: undefined,
};

export function filtersReducer(state: FiltersReducerState, action: FiltersActionTypes) {
  switch (action.type) {
    case FILTER_ACTIONS.UPDATE_NETWORKS:
      return { ...state, networks: action.payload };
    case FILTER_ACTIONS.UPDATE_ORDER_TYPES:
      return { ...state, orderTypes: action.payload };
    case FILTER_ACTIONS.UPDATE_STATUS:
      return { ...state, status: action.payload };
    case FILTER_ACTIONS.UPDATE_TIME:
      return { ...state, time: action.payload };
    case FILTER_ACTIONS.UPDATE_ALL_FILTERS:
      return action.payload;
    case FILTER_ACTIONS.CLEAR:
      return DEFAULT_FILTERS_STATE;
    default:
      const exhaustiveCheck: never = action;
      return exhaustiveCheck;
  }
}
